// src/api_scripts/createHolidayList.js
import { createApiClient } from "../apiClient";

const createHolidayList = async (holidayListData, orgId, accessToken, setProgress) => {
  const { name } = holidayListData.name;

  setProgress(`Attempting to create Holiday List: "${name}"...`, "info" );

  // API endpoint for creating a new Holiday List
  const relativeUri = `organization/${orgId}/holiday-list`;

  try {
    const apiClient = createApiClient(accessToken);
    const response = await apiClient.post(relativeUri, holidayListData);

    const newHolidayList = response.data; // The API returns the created resource directly

    console.log("Create Holiday List API Response Data:", newHolidayList);

    setProgress(`Successfully created Holiday List "${name}" (ID: ${newHolidayList.id}).`, "info"); 

    return newHolidayList.id; // Return the created holiday list object (includes its ID)

  } catch (error) {
    console.error(`Error creating Holiday List "${name}":`, error);

    let errorMessage = `Error creating Holiday List "${name}": ${error.message || String(error)}`;

    if (error.response && error.response.data) {
      if (error.response.data.error && error.response.data.error.reason) {
        errorMessage += ` (Reason: ${error.response.data.error.reason})`;
      } else if (error.response.data.message) {
        errorMessage += ` (Detail: ${error.response.data.message})`;
      } else if (typeof error.response.data === 'string') {
        errorMessage += ` (Response: ${error.response.data})`;
      }
    }

    setProgress(errorMessage, "error");
    throw error;
  }
};

export default createHolidayList;
